import { createAction } from '@reduxjs/toolkit';

import { NAME } from './constants';

export const checkStreak = createAction(`${NAME}/checkStreak`);
